export default __webpack_public_path__ + "static/media/landscape_complete1000x750.8181a44e.jpg";